// extracted by mini-css-extract-plugin
export default {"icon":"SelectTemplate_icon__SJABa"};